import { useCallback } from 'react';
import { useGetEditOrActual } from '../../../../../state/CampaignSettings/selectors/useGetEditOrActual';
import { CampaignMessage } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorState';
import { SendEmailMessage } from 'sections/onsite-campaigns/types';

export const useGetSendEmailSelector = () => {
  const state = useGetEditOrActual();

  return useCallback((id: string): CampaignMessage<SendEmailMessage> => state.messages[id], [state.messages]);
};
